import EnumObject from '@/domain/enum-object.entity';
import RuleResponse from './rule-response';

export default class RuleGroupResponse {
  id: string;

  name: string;

  status: EnumObject;

  createdDate: string;

  createdBy: string;

  businessUnitId: string;

  rules: RuleResponse[];

  constructor(obj: any = {}) {
    this.id = obj.id || '';
    this.status = EnumObject.of(obj.status) || '';
    this.name = obj.name || '';
    this.createdDate = obj.createdDate || '';
    this.createdBy = obj.createdBy || '';
    this.businessUnitId = obj.businessUnitId || '';
    this.rules = RuleResponse.ofList(obj.rules);
  }

  public static of(obj: any = {}): RuleGroupResponse {
    return new RuleGroupResponse(obj || {});
  }

  public static ofList(obj: any[] = []): RuleGroupResponse[] {
    return obj.map(this.of);
  }
}
